import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
const approveMultipleSecondHandSupplyMutation = gql`mutation update_multiple_second_hand_supplies($idArray:[uuid!]){
  update_second_hand_supplies(where:{id:{_in:$idArray}},
  _set:{status: "APPROVED"}){
    affected_rows
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class ApproveMultipleService {

  constructor(private apollo: Apollo) { }

  approveMultipleSecondHandSupply(idArray: any){
    return this.apollo.use('external').mutate({
      mutation: approveMultipleSecondHandSupplyMutation,
      variables:{
        idArray
      }
    }).toPromise();
  }
}

